import DomUtils from '@/core/utils/DomUtils';

/**
 * Глобальный тултип-сервис. Один DOM-узел на весь проект.
 * Компоненты вызывают show(anchor, text) на mouseenter и hide() на mouseleave.
 * Позиционирование — через DomUtils.getTooltipPosition.
 */
class TooltipService {
	private static element: HTMLElement | null = null;

	/** Показывает тултип с текстом content, спозиционированный относительно anchor */
	static show(anchor: HTMLElement, content: string): void {
		if (!content) {
			return;
		} else {
			const el = this.ensureElement();
			el.textContent = content;
			el.style.display = 'block';

			const { top, left } = DomUtils.getTooltipPosition(anchor, el);
			el.style.top  = top + 'px';
			el.style.left = left + 'px';
		}
	}

	/** Прячет тултип */
	static hide(): void {
		if (this.element) {
			this.element.style.display = 'none';
		} else {
			// узел ещё не создавался — прятать нечего
		}
	}

	/** Создаёт и настраивает DOM-узел тултипа, добавляет его в body */
	private static createElement(): HTMLElement {
		const el = document.createElement('div');

		el.className           = 'global-tooltip';
		el.style.position      = 'fixed';
		el.style.pointerEvents = 'none';
		el.style.display       = 'none';

		document.body.appendChild(el);

		return el;
	}

	/** Лениво создаёт единственный узел тултипа в body */
	private static ensureElement(): HTMLElement {
		if (this.element) {
			return this.element;
		} else {
			this.element = this.createElement();
			return this.element;
		}
	}

}

export default TooltipService;
